module.exports = __webpack_public_path__ + "static/ruscitto-bc-5ce3fb90bc81960ee7f2cdf9bb8f4ade.png";